import React from "react";
import { useTranslation } from "react-i18next";

export default function HaProfileConfigRTO() {
  const { t } = useTranslation("help");

  const configData = {
    profile_type: "rto",
    test_file_paths: {
      dos: [],
      llm: [],
      mcp: [],
      rto: [
        {
          file_name: "",
          file_path: "",
          file_creation_method: ""
        }
      ],
      docs: [],
      frame: [],
      prompts: [],
      custom_decision_tree: [],
      rc_prompts: []
    },
    rto_tests: {
      sub: {
        doc_upload_tests: {
          enabled: false
        },
        mid_size_prompts: {
          enabled: false
        },
        reg_size_prompts: {
          enabled: false
        },
        large_size_prompts: {
          enabled: false
        }
      },
      enabled: false,
      average_response_time: ""
    }
  };

  return (
    <div className="endpoint-container">
      <a href="#profile-config-rto" className="endpoint-title">
        {t("HaProfileConfigRTO.title", "Profile Config (Response Time Optimization)")}
      </a>

      <pre className="code-block">
        <code>{JSON.stringify(configData, null, 2)}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 2;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
          }
        }
      `}</style>
    </div>
  );
}